import React from "react";
import { useTranslation } from "react-i18next";

function CurrencyConverter({ value, currency}) {
  const { t } = useTranslation();

  return (
    <>
      {(currency === "EUR" ? "€" : currency === "USD" ? "$" : currency === "GBP" ? "£" : t("currency_symbol")) + value?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
    </>
  );
}

export default CurrencyConverter;
